"use client";

import { Config } from "@puckeditor/core";
import { renderConfig as defaultConfig } from "./puck/config";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { ErrorBoundary } from "./ui/ErrorBoundary";

export function PuckRenderer({
  data,
  initialData,
  configOverride,
  siteSettings,
  hideHeader,
  hideFooter,
}: {
  data: any;
  initialData?: any;
  configOverride?: Config;
  siteSettings?: any;
  hideHeader?: boolean;
  hideFooter?: boolean;
}) {
  const root = data?.root || {};
  const content = Array.isArray(data?.content) ? data.content : [];
  const { header = {} } = root.props || {};
  const activeConfig = configOverride || defaultConfig;
  const announcementBlock = content.find((block: any) => block?.type === "AnnouncementBar");
  const pageContent = content.filter((block: any) =>
    block?.type !== "AnnouncementBar" &&
    block?.type !== "SiteFooterBlock" &&
    block?.type !== "SiteFooter" &&
    block?.type !== "Footer"
  );

  return (
    <div className="flex flex-col min-h-screen font-sans">
      {!hideHeader && (
        <SiteHeader
          {...header}
          announcement={announcementBlock?.props}
          initialSettings={siteSettings}
        />
      )}
      <main id="main" className="flex-grow" aria-label="Page content">
        {pageContent.length === 0 ? (
          <div className="py-20 text-center">
            <p className="text-slate-500">No content found for this page.</p>
          </div>
        ) : (
          pageContent.map((block: any, index: number) => {
            if (!block || !block.type) return null;

            const type = block.type;
            const componentConfig = (activeConfig.components as any)[type];
            // Seeded and legacy pages often store only an id for a block. Puck applies
            // defaultProps in the editor, but this lightweight public renderer must do
            // the same or headings, CTA labels, and supporting content render empty.
            const safeProps = {
              ...(componentConfig?.defaultProps || {}),
              ...(block.props || {}),
            };

            if (componentConfig && componentConfig.render) {
              const Render = componentConfig.render;
              return (
                <ErrorBoundary key={safeProps.id || block.id || `${block.type}-${index}`}>
                  <Render
                    {...safeProps}
                    id={safeProps.id || block.id || `${block.type}-${index}`}
                    data-block={block.type}
                    dataBlock={block.type}
                    puck={{ renderDropZone: () => null }}
                    initialData={initialData}
                  />
                </ErrorBoundary>
              );
            }

            return null;
          })
        )}
      </main>
      {!hideFooter && <SiteFooter initialSettings={siteSettings} />}
    </div>
  );
}
